import { render, staticRenderFns } from "./CardProducts.vue?vue&type=template&id=c6294140&scoped=true&"
import script from "./CardProducts.vue?vue&type=script&lang=js&"
export * from "./CardProducts.vue?vue&type=script&lang=js&"
import style0 from "./CardProducts.vue?vue&type=style&index=0&id=c6294140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6294140",
  null
  
)

export default component.exports